import { RestLink } from 'apollo-link-rest';
import EventGallery from './eventGallery';
import GalleryGroup from './galleryGroup';
import SourceEvent from './sourceEvent';
import SearchFragment from './searchFragment';
import SearchResultOverview from './searchResultOverview';
import TypePatcherTable = RestLink.TypePatcherTable;
import EventPhoto from './eventPhoto';

export default {
  EventGallery,
  EventPhoto,
  GalleryGroup,
  SourceEvent,
  SearchFragment,
  SearchResultOverview,
} as TypePatcherTable;
